import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import {
  FailedFilesListQueryParam,
  FailedFilesListSortField
} from "@saleor/poUpload/urls";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import { poUploadSettingsUrl, poUploadUrl } from "./urls";
import POUploadSettingsView from "./views/POUploadSettingsView";
import POUploadView from "./views/POUploadView";

const POUploadSection = () => {
  const intl = useIntl();

  const POUploadComponent: React.FC<RouteComponentProps<any>> = () => {
    const qs = parseQs(location.search.substr(1));

    const params: FailedFilesListQueryParam = asSortParams(
      qs,
      FailedFilesListSortField,
      FailedFilesListSortField.UPDATED_AT
    );
    return <POUploadView params={params} />;
  };

  const POUploadSettingsComponent: React.FC<RouteComponentProps<any>> = () => (
    <POUploadSettingsView />
  );

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.poUpload)} />
      <Switch>
        <Route exact path={poUploadUrl} render={POUploadComponent} />
        <Route
          exact
          path={poUploadSettingsUrl}
          render={POUploadSettingsComponent}
        />
      </Switch>
    </>
  );
};

export default POUploadSection;
